import { FC, ReactNode } from 'react';
import { Text } from '@vtex/admin-ui';

type Props = {
  type?:
    | 'pageTitle'
    | 'title1'
    | 'title2'
    | 'action1'
    | 'action2'
    | 'display'
    | 'body'
    | 'detail';
  children: JSX.Element | string | (JSX.Element | string)[] | ReactNode;
  className?: string;
};

export const Typography: FC<Props> = ({ type, children, className }) => {
  return (
    <Text className={className} variant={type}>
      {children}
    </Text>
  );
};
